export default __webpack_public_path__ + "static/media/id-card.8876c19d.svg";